import { createFileRoute } from '@tanstack/react-router';

/**
 * Agent 상세 라우트 (/agents/$agentId)
 *
 * 상세 페이지는 로그인 없이 접근 가능합니다.
 * 에이전트 실행 시에만 인증 체크를 수행합니다 (useOperatorPanelState에서 처리).
 * 컴포넌트는 $agentId.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/agents/$agentId')({});
